module.exports = __webpack_public_path__ + "static/media/crocodile(31).f121a474.PNG";